// extracted by mini-css-extract-plugin
export var icon = "_7a-1";
export var subtext = "_7a-0";